import { useMemo } from 'react';

// Trans lander has a single fixed 5-step flow.
// `summary` is a marker that triggers navigation to /summary in Home.jsx.
export const useSteps = () => {
  const getActiveSteps = useMemo(() => (allSteps) => allSteps, []);

  return {
    getActiveSteps,
  };
};
